export default __webpack_public_path__ + "media/children2-75773.eac2f7fc.mp3";